import { h } from 'preact';
import Container from '../container';
import HistoricalData from './historical';
import SplitsDividends from './splits-dividends';
import style from './style';
import { FinanceSpinner } from '../glyphs';
import { Text } from 'preact-i18n';
import cx from 'classnames';

const INTL_NS = 'historical-data-panel.divSplit';

export default function DataPanel({ view, data, symbolTypeCode, width, ...props }) {
	return  (
		!data ? <FinanceSpinner /> : (
			view.value === 'Historical Prices' ?
				<HistoricalData maxRows="10000000" data={data.historical}  symbolTypeCode={symbolTypeCode} {...props} />
				:
				<div class={style.splitsDividends}>
					<Container class={cx(style.sdCont, width > 630 && style.wide)} parent>
						<Container title={<Text id={`${INTL_NS}.dividends`} />}>
							<SplitsDividends header={<Text id={`${INTL_NS}.dividend`} />} maxRows="10000000" data={data.dividends} {...props} />
						</Container>
						<Container title={<Text id={`${INTL_NS}.stockSplits`} />}>
							<SplitsDividends header={<Text id={`${INTL_NS}.split`} />} maxRows="10000000" data={data.splits} {...props} />
						</Container>
					</Container>
				</div>
		)
	);
}
